<section class="login-page">
  <mat-card class="login-card">
    <div class="login-copy">
      <p class="eyebrow">Admin Access</p>
      <h1>Login to Vaggit Admin</h1>
      <p class="subtitle">Enter your username and password to continue.</p>
    </div>

    <form class="login-form" [formGroup]="form" (ngSubmit)="onSubmit()">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Username</mat-label>
        <input
          matInput
          formControlName="username"
          placeholder="Enter username"
          (input)="clearLoginError()"
        />
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Password</mat-label>
        <input
          matInput
          [type]="showPassword ? 'text' : 'password'"
          formControlName="password"
          placeholder="Enter password"
          (input)="clearLoginError()"
        />
        <button
          mat-icon-button
          matSuffix
          type="button"
          [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'"
          (click)="showPassword = !showPassword"
        >
          <mat-icon>{{ showPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
      </mat-form-field>

      @if (loginError) {
      <p class="login-error">{{ loginError }}</p>
      }

      <button mat-raised-button color="primary" type="submit" [disabled]="isSubmitting">
        {{ isSubmitting ? 'Logging in...' : 'Login' }}
      </button>
    </form>

    <p class="auth-link-row">
      Need to create the first admin?
      <a routerLink="/register">Register</a>
    </p>
  </mat-card>
</section>
